import styles from './styles.module.scss'

type Props = {
  store?: boolean
  compact?: boolean
}

const RewardCard = ({ store = false, compact = false }: Props): JSX.Element => (
  <div
    className={`${styles.rewardCard} ${store ? styles.storeReward : styles.referrerReward} ${
      compact ? styles.compact : ''
    }`}
  >
    <div className={styles.rewardIcon}>
      <img src={`/partner-introduction/${store ? 'store_icon.svg' : 'gift_icon.svg'}`} alt="" />
    </div>
    <div>
      <span className={styles.rewardWho}>
        {compact
          ? store
            ? '導入店舗 サインボーナス'
            : '紹介者'
          : store
          ? '導入した店舗・施設に'
          : '紹介してくれたあなたに'}
      </span>
      <span className={styles.rewardAmount}>
        {store ? '10,000' : '15,000'}
        <small>円</small>
      </span>
      {!compact ? (
        <span className={styles.rewardLabel}>
          {store ? 'ecbo cloak 導入のサインボーナス' : '紹介した店舗が導入・掲載開始したら'}
        </span>
      ) : null}
    </div>
  </div>
)

export default RewardCard
